/**
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var regions_1 = require("../../regions");

var MenuContext = function () {
  function MenuContext(target, selectedRegions, numRows, numCols) {
    this.target = target;
    this.selectedRegions = selectedRegions;
    this.numRows = numRows;
    this.numCols = numCols;
    this.regions = regions_1.Regions.overlapsRegion(selectedRegions, target) ? selectedRegions : [target];
  }

  MenuContext.prototype.getTarget = function () {
    return this.target;
  };

  MenuContext.prototype.getSelectedRegions = function () {
    return this.selectedRegions;
  };

  MenuContext.prototype.getRegions = function () {
    return this.regions;
  };

  MenuContext.prototype.getUniqueCells = function () {
    return regions_1.Regions.enumerateUniqueCells(this.regions, this.numRows, this.numCols);
  };

  return MenuContext;
}();

exports.MenuContext = MenuContext;